import { createSlice } from "@reduxjs/toolkit";

import {
  fetchMyActiveRouteAssignment,
  fetchMyRouteSchedule,
  fetchRouteAreas,
  fetchRouteAssignments,
  fetchRoutePoints,
  fetchWorkRouteAnalytics,
  fetchWorkRoutes,
} from "./workRoutesThunk";

const initialState = {
  routeAreas: [],
  routePoints: [],
  workRoutes: [],  
  routeAssignments: [],
  assignment: {},
  myRouteSchedule: [],
  myRouteScheduleLoading: false,
  analytics: {
    overview: {},
    employee_stats: [],
    route_completion: [],
    visit_durations: [],
  },
  loading: false,
  error: null,
};

const workRoutesSlice = createSlice({
  name: "workRoutes",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder

      .addCase(fetchRoutePoints.pending, (state) => {
        state.loading = true;
      })

      .addCase(fetchRoutePoints.fulfilled, (state, action) => {
        state.loading = false;
        state.routePoints = action.payload || [];
      })

      .addCase(fetchRoutePoints.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(fetchRouteAreas.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(fetchRouteAreas.fulfilled, (state, action) => {
        state.loading = false;
        state.routeAreas = action.payload || [];
      })
      .addCase(fetchRouteAreas.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(fetchWorkRoutes.pending, (state) => {
        state.loading = true;
      })

      .addCase(fetchWorkRoutes.fulfilled, (state, action) => {
        state.loading = false;
        state.workRoutes = action.payload || [];
      })

      .addCase(fetchWorkRoutes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      
      .addCase(fetchRouteAssignments.pending, (state) => {
        state.loading = true;
      })

      .addCase(
        fetchRouteAssignments.fulfilled,
        (state, action) => {
          state.loading = false;

          state.routeAssignments =
            action.payload || [];
        }
      )

      .addCase(
        fetchRouteAssignments.rejected,
        (state, action) => {
          state.loading = false;
          state.error = action.payload;
        }
      )
      .addCase(
        fetchWorkRouteAnalytics.fulfilled,
        (state, action) => {
          state.analytics =
            action.payload || {};
        }
      )
      .addCase(
        fetchMyActiveRouteAssignment.fulfilled,
        (state, action) => {
          state.assignment = action.payload || {};
        }
      )
      .addCase(fetchMyRouteSchedule.pending, (state) => {
        state.myRouteScheduleLoading = true;
      })
      .addCase(fetchMyRouteSchedule.fulfilled, (state, action) => {
        state.myRouteScheduleLoading = false;
        state.myRouteSchedule = action.payload || [];
      })
      .addCase(fetchMyRouteSchedule.rejected, (state, action) => {
        state.myRouteScheduleLoading = false;
        state.error = action.payload;
      });
        },
      });

export default workRoutesSlice.reducer;